import * as vp from 'vopay';
import { FunctionComponent, useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import EftFundingTransactionContainer from './EftFundingTransactionContainer';
import EftWithdrawTransactionContainer from './EftWithdrawTransactionContainer';
import InteracMoneyRequestTransactionContainer from './InteracMoneyRequestTransactionContainer';
import InteracBulkPayoutTransactionContainer from './InteracBulkPayoutTransactionContainer';
import CreditCardTransactionContainer from './CreditCardTransactionContainer';

const { Title, Box, Badge } = vp;

type FC = FunctionComponent;

const Transaction: FC = () => {
  const { TransactionID } = useParams<{ TransactionID: string }>();
  const query = new URLSearchParams(useLocation().search);
  const type = decodeURIComponent(query.get('type') || '');

  const [transId, setTransactionId] = useState<string>('');

  if (!transId || transId !== TransactionID) {
    setTransactionId(TransactionID);
  }

  useEffect(() => {}, [transId]);

  return (
    <div>
      <Title title={TransactionID} />
      <Box pt="sm" pb="sm" gap="sm">
        <Badge label={type || ''} color="primary" />
      </Box>
      {type === vp.TransactionType.EFT_FUNDING && (
        <EftFundingTransactionContainer TransactionID={transId} Type={type} />
      )}
      {type === vp.TransactionType.EFT_WITHDRAWAL && (
        <EftWithdrawTransactionContainer TransactionID={transId} Type={type} />
      )}
      {type === vp.TransactionType.INTERACT_MONEY_REQUEST && (
        <InteracMoneyRequestTransactionContainer TransactionID={transId} Type={type} />
      )}
      {type === vp.TransactionType.INTERACT_BULK_PAYOUT && (
        <InteracBulkPayoutTransactionContainer TransactionID={transId} Type={type} />
      )}
      {type === vp.TransactionType.CREDIT_CARD && (
        <CreditCardTransactionContainer TransactionID={transId} Type={type} />
      )}
    </div>
  );
};

export default Transaction;
